// extracted by mini-css-extract-plugin
export var chevron = "_m1-3";
export var chevronRotated = "_m1-4";
export var image = "_m1-1";
export var imageContainer = "_m1-0";
export var shippingAddress = "_m1-2";